import React from 'react';
import '../styles/SimpleHeader.css';

const SimpleHeader = () => {
  return (
    <header className="simple-header">
      <div className="simple-header-container">
        <div className="logo">
          <img src={`${process.env.PUBLIC_URL}/images/iqos-logo.svg`} alt="IQOS" />
        </div>
      </div>
    </header>
  );
};

export default SimpleHeader;


